export default {"src":"/_next/static/media/concept.0bb7e378.svg","height":220,"width":220};